import React from 'react';

/**
 * Since hubspot sometimes returns HTML for titles, we need to conditionally render an
 * element with innerHTML or not so that the html tags dont render as plain text
 *
 * @param {('3'|'4')} level - the heading level
 * @param isSearch
 * @param title
 * @param attrs
 * @returns {JSX.Element}
 */
export const titleElement = (level, isSearch, title) => {
  const titleAttrs = {
    dangerouslySetInnerHTML: { __html: title },
  };

  const TitleTag = `h${level}`;
  return isSearch ? <TitleTag {...titleAttrs}></TitleTag> : <TitleTag>{title}</TitleTag>;
};
